import { useMemo } from 'react';
import { Route, type RouteProps } from 'react-router-dom';
import { CowWaveLoader } from '../components/CowWaveLoader';
import { ErrorOverlay } from '../components/ErrorOverlay';
import { useWorkspaceTypes } from '../hooks/useWorkspaces';

export const ProtectedRoute = <Path extends string>({ children, render, component, ...rest }: RouteProps<Path>) => {
  const { workspaceTypes, areWorkspaceTypesLoaded } = useWorkspaceTypes();

  const isStudioPermissible = useMemo(() => {
    return !!workspaceTypes.length;
  }, [workspaceTypes]);

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!areWorkspaceTypesLoaded) return <CowWaveLoader />;
        if (!isStudioPermissible) {
          return (
            <ErrorOverlay title="You do not have permission to access Studio. Please contact your administrator to request access." />
          );
        }
        if (render) return render(routeProps);
        if (component) {
          const Component = component;
          return <Component {...routeProps} />;
        }
        return <>{children}</>;
      }}
    />
  );
};
